import { loadModules } from 'esri-loader';
import CombinedLayerControlWidget from './CombinedLayerControlWidget.js';

/**
 * Load ArcGIS AMD modules (for esri-loader apps) and map them to the widget's expected dependencies.
 */
export async function loadWidgetEsriDeps() {
  const [
    FeatureLayer,
    MapImageLayer,
    TileLayer,
    ImageryLayer,
    WMSLayer,
    SimpleRenderer,
    SimpleMarkerSymbol,
    SimpleLineSymbol,
    SimpleFillSymbol,
    esriRequest,
    OAuthInfo,
    IdentityManager,
  ] = await loadModules([
    'esri/layers/FeatureLayer',
    'esri/layers/MapImageLayer',
    'esri/layers/TileLayer',
    'esri/layers/ImageryLayer',
    'esri/layers/WMSLayer',
    'esri/renderers/SimpleRenderer',
    'esri/symbols/SimpleMarkerSymbol',
    'esri/symbols/SimpleLineSymbol',
    'esri/symbols/SimpleFillSymbol',
    'esri/request',
    'esri/identity/OAuthInfo',
    'esri/identity/IdentityManager',
  ]);

  return {
    FeatureLayer,
    MapImageLayer,
    TileLayer,
    ImageryLayer,
    WMSLayer,
    SimpleRenderer,
    SimpleMarkerSymbol,
    SimpleLineSymbol,
    SimpleFillSymbol,
    esriRequest,
    OAuthInfo,
    IdentityManager,
  };
}

/**
 * Convenience helper for parent apps using esri-loader (ArcGIS AMD).
 */
export async function createCombinedControlForEsriLoader(options) {
  const esri = await loadWidgetEsriDeps();
  return new CombinedLayerControlWidget({
    ...options,
    esri,
  });
}

